import React from 'react';
import PropTypes from 'prop-types';

import BEM from '../../Utilities/BEM/index.jsx';


class SingleSetting extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.input = React.createRef();
  }

  onChange(event) {
    this.props.onChange(event.target.checked, this.props.name);
  }

  /**
   * re-implement the `indeterminate` check here, as the ref isn't set on first
   * render
   */
  componentDidMount() {
    if (this.props.indeterminate) {
      if (this.input.current) {
        this.input.current.indeterminate = this.props.indeterminate;
      }
    }
  }

  render() {
    var setting = this.props.setting;
    var variants = [];

    var inputProps = {};
    inputProps.type = 'checkbox';
    inputProps.name = this.props.name;
    inputProps.value = '1';
    inputProps.id = this.props.name;
    inputProps.className = 'custom-control-input';
    inputProps.onChange = this.onChange;
    inputProps.disabled = this.props.disabled;

    if (inputProps.disabled) {
      inputProps.checked = false;

      variants.push('disabled');
    } else {
      inputProps.checked = this.props.checked;
    }

    if (this.props.variant) {
      variants.push(this.props.variant);
    }

    if (this.input.current) {
      this.input.current.indeterminate = this.props.indeterminate;
    }

    return (
      <tr
        className={BEM.classString('cs-user-notification-settings-row', variants)}
      >
        <td className="cs-user-notification-settings-row__label">
          <label htmlFor={this.props.name}>{this.props.label}</label>
        </td>
        <td className="cs-user-notification-settings-row__value">
          <div className="custom-control custom-checkbox">
            <input ref={this.input} {...inputProps} />
            <label
              className="custom-control-label"
              htmlFor={this.props.name}
            ></label>
          </div>
        </td>
      </tr>
    );
  }
}


SingleSetting.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  variant: PropTypes.string,
  indeterminate: PropTypes.bool
};


class UserNotificationSetting extends React.Component {
  constructor(props) {
    super(props);

    this.selectAll = this.selectAll.bind(this);
    this.selectOne = this.selectOne.bind(this);
  }

  selectAll(value, name) {
    if (value) {
      this.props.onChange('1', name);
    } else {
      this.props.onChange('0', name);
    }
  }

  selectOne(value, name) {
    if (value) {
      this.selectOption(name);
    } else {
      this.deselectOption(name);
    }
  }

  /*
   * returns true/false indicating whether a specific option has been selected.
   * An option is selected if either the value is '1' (meaning all selected),
   * or the option is explicitly listed in the value ('...,<name>:1,...'),
   * or if the value is the "list of selected options", but the value is absent
   * from the list (meaning the value is new).
   */
  optionSelected(name) {
    var result = false;
    var value = this.props.setting.value;

    switch (value) {
      // all selected.
      case '1':
        result = true;

        break;
      // none selected.
      case '0':
        break;
      default:
        if (value) {
          var valueArray = value.split(',');

          if (valueArray.length) {
            // option is explicitly selected
            result = (valueArray.indexOf(name + ':1') > -1);

            if (! result) {
              // option is absent from the list
              result = (valueArray.indexOf(name + ':0') == -1);
            }
          }
        }
    }


    return result;
  }

  /**
   * select's an option.
   */
  selectOption(name) {
    var setting = this.props.setting;

    switch (setting.value) {
      case '1':
        break;
      // nothing is selected.
      case '0':
        valueArray = [];
        for (var i = 0; i < setting.options.length; i++) {
          var option = setting.options[i];

          if (option.id == name) {
            valueArray.push(option.id + ':1');
          } else {
            valueArray.push(option.id + ':0');
          }
        }

        this.props.onChange(valueArray.join(','), this.props.name);
        break;
      // the list is already "some selected".
      default:
        var valueArray = setting.value.split(',');

        if (valueArray.length) {
          // find the explicitly deselected option
          var index = valueArray.indexOf(name + ':0');
          if (index > -1) {
            valueArray[index] = name + ':1';
          } else {
            // it is not present, so add it to the list
            var index = valueArray.indexOf(name + ':1');
            if (index == -1) {
              // doesn't exist, add it.
              valueArray.push(name + ':1');
            }
          }

          // see whether all options are selected, and set to the special '1'
          // if so.
          var allTrue = true;
          for (var i = 0; i < setting.options.length; i++) {
            var option = setting.options[i];

            var index = valueArray.indexOf(option.id + ':1');
            if (index == -1) {
              // could not find the option set to true, see if it is set to
              // false
              index = valueArray.indexOf(option.id + ':0');
              if (index > -1) {
                allTrue = false;
                break;
              }
            }
          }
          if (allTrue) {
            this.props.onChange('1', this.props.name);
          } else {
            this.props.onChange(valueArray.join(','), this.props.name);
          }
        }
    }
  }

  /**
   * deselect's an option.
   */
  deselectOption(name) {
    var setting = this.props.setting;

    switch (setting.value) {
      // revert from a 'select all' value to a 'everything except this option'
      // value
      case '1':
        valueArray = [];
        for (var i = 0; i < setting.options.length; i++) {
          var option = setting.options[i];

          if (option.id == name) {
            valueArray.push(option.id + ':0');
          } else {
            valueArray.push(option.id + ':1');
          }
        }

        this.props.onChange(valueArray.join(','), this.props.name);
        break;
      // nothing is selected anyway.
      case '0':
        break;
      // the list is already "some selected".
      default:
        var valueArray = setting.value.split(',');

        if (valueArray.length) {
          // find the explicitly selected option
          var index = valueArray.indexOf(name + ':1');
          if (index > -1) {
            valueArray[index] = name + ':0';
          } else {
            // explicitly 'not' selected.
            var index = valueArray.indexOf(name + ':0');
            if (index == -1) {
              // doesn't exist, add it.
              valueArray.push(name + ':0');
            }
          }

          // see whether all options are deselected, and set to the special '0'
          // if so.
          var allFalse = true;
          for (var i = 0; i < setting.options.length; i++) {
            var option = setting.options[i];

            var index = valueArray.indexOf(option.id + ':0');
            if (index == -1) {
              // could not find the option set to false, therefore it is
              // selected
              allFalse = false;
              break;
            }
          }
          if (allFalse) {
            this.props.onChange('0', this.props.name);
          } else {
            this.props.onChange(valueArray.join(','), this.props.name);
          }
        }
    }
  }

  render() {
    var setting = this.props.setting;
    var options = [];

    var optionProps = {};
    optionProps.name = this.props.name;
    optionProps.label = this.props.label;
    optionProps.disabled = this.props.disabled || (! setting.enabled);
    optionProps.checked = (setting.value == '1');
    optionProps.indeterminate = ! ((setting.value == '1') || (setting.value == '0'));
    optionProps.onChange = this.selectAll;

    var singleOption = ( <SingleSetting {...optionProps} /> );

    if (setting && setting.options) {
      var value = setting.value;

      for (var i = 0; i < setting.options.length; i++) {
        var option = setting.options[i];

        optionProps = {};
        optionProps.name = option.id;
        optionProps.label = option.label;
        optionProps.disabled = this.props.disabled || (! setting.enabled);
        optionProps.checked = this.optionSelected(option.id);
        optionProps.onChange = this.selectOne;
        optionProps.variant = 'multiple';

        options.push( <SingleSetting key={i} {...optionProps} /> );
      }
    }


    return (
      <React.Fragment>
        {singleOption}
        {options}
      </React.Fragment>
    );
  }
}


UserNotificationSetting.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  setting: PropTypes.shape({
    value: PropTypes.string,
    options: PropTypes.array
  }),
  onChange: PropTypes.func
};


export default UserNotificationSetting;

